import { render, staticRenderFns } from "./partyinitialization.vue?vue&type=template&id=6092316b&"
import script from "./partyinitialization.vue?vue&type=script&lang=js&"
export * from "./partyinitialization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports